// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__EUhEB","loading":"PrintResults_loading__s9PMY","pdfWrapper":"PrintResults_pdfWrapper__+sOWx"};